import {LocalGithubUser} from "../types";

export const defaultUser: LocalGithubUser = {
    login: "KotenkoNata",
    avatar: 'https://avatars.githubusercontent.com/u/35960689?v=4',
    name: 'Nataliia',
    company: '',
    blog: '',
    location: 'Ukraine, Lviv',
    bio: '',
    twitter: 'Kotenko_Natalia',
    repos: 61,
    followers: 6,
    following: 6,
    created: '2018-01-30T12:37:35Z'
}